import React from 'react';
import styles from './MultiAvatar.module.scss';
import { Text } from './typography';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';
import Icon from './Icon';

export default function MultiAvatar({
  users = [],
  maxLength = 2,
  className,
  size = 'sm',
  onUserRemoved,
}) {
  const userMap = new Map();
  users.forEach((u) => userMap.set(u?.id, u));
  const flattenedUsers = Array.from(userMap.values())?.filter(Boolean);
  return (
    <div className={classNames(styles.container, className)}>
      {flattenedUsers
        .slice(0, maxLength)
        .map(({ id, avatarUrl, firstName, lastName, workRoles }) => {
          const user = { id, avatarUrl, firstName, lastName, workRoles };
          return (
            <Tooltip
              key={`tooltip:${id}`}
              title={
                <div>
                  <Text
                    weight="semiBold"
                    noMargin
                    color="white"
                  >{`${firstName} ${lastName}`}</Text>
                  {!!workRoles?.length && (
                    <Text size="sm" noMargin color="white">
                      {workRoles.map((r) => r.title)?.join(', ') || 'None'}
                    </Text>
                  )}
                </div>
              }
              arrow
            >
              {!!onUserRemoved ? (
                <div className={styles.avatarWrapper}>
                  <img
                    key={`avatar:${id}`}
                    className={classNames(styles.avatar, styles[size])}
                    alt={firstName}
                    src={avatarUrl}
                  />
                  <Icon
                    className={styles.closeIcon}
                    baseClassName="material-icons-outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      onUserRemoved(user);
                    }}
                  >
                    close
                  </Icon>
                </div>
              ) : (
                <img
                  key={`avatar:${id}`}
                  className={classNames(styles.avatar, styles[size])}
                  alt={firstName}
                  src={avatarUrl}
                />
              )}
            </Tooltip>
          );
        })}
      {flattenedUsers.length > maxLength && (
        <Tooltip
          key={`tooltip`}
          title={flattenedUsers
            ?.slice(maxLength - 1)
            .map(({ id, firstName, lastName, workRoles }) => (
              <div>
                <Text
                  weight="semiBold"
                  noMargin
                  color="white"
                  key={`extraUser:${id}`}
                >{`${firstName} ${lastName}`}</Text>{' '}
                {!!workRoles?.length && (
                  <Text size="sm" noMargin color="white">
                    {workRoles.map((r) => r.title)?.join(', ') || 'None'}
                  </Text>
                )}
              </div>
            ))}
          arrow
        >
          <div>
            <Text
              className={styles.overflowText}
              size="sm"
              weight="semiBold"
              color="accentPrimary"
              noMargin
            >
              {`+ ${flattenedUsers.length - maxLength}`}
            </Text>
          </div>
        </Tooltip>
      )}
    </div>
  );
}
